<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/hello' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>应用基础配置</el-breadcrumb-item>
      <el-breadcrumb-item>渠道配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:15px;">
      <el-form
        ref="queryForm"
        :model="userSearchData"
        size="small"
        :inline="true"
        label-width="68px"
      >
        <el-form-item label="时间">
          <el-date-picker
            v-model="userSearchData.time"
            style="width: 220px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchDataInfo()"
            >搜索</el-button>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-plus"
            @click="addversion"
            >新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table v-loading="pageloading" border :data="versionListData" stripe style="width: 100%">
        <el-table-column prop="Id" label="序列号" width="100"></el-table-column>
        <el-table-column prop="channel_id" label="渠道ID" width="100"></el-table-column>
        <el-table-column prop="name" label="渠道名称" width="200"></el-table-column>
        <el-table-column prop="content" label="渠道描述" width="200"></el-table-column>
        <el-table-column prop="status" label="显示状态" width="100">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 0">不显示</el-tag>
            <el-tag type="success" v-if="scope.row.status == 1">显示</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="auto_type" label="是否自动计算" width="120">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.auto_type == 0">不自动计算</el-tag>
            <el-tag type="success" v-if="scope.row.auto_type == 1">自动计算</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180">
          <template slot-scope="scope">
            {{changeDateFormat(scope.row.create_time)}}
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="180">
          <template slot-scope="scope">
            {{changeDateFormat(scope.row.update_time)}}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="edit(scope.row)"
              >编辑</el-button>
            <el-button type="danger" size="mini" @click="deleteDataInfo(scope.row)"
                >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
      <!-- 分页功能 -->
    </el-card>

    <!-- 添加版本弹框 -->
    <el-dialog v-loading="editpageloading" title="新增信息" :visible.sync="addVisible" width="50%">
      <el-form
        :model="addruleForm"
        ref="addruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="渠道ID" prop="channel_id">
          <el-input v-model="addruleForm.channel_id"></el-input>
        </el-form-item>
        <el-form-item label="渠道名称" prop="name">
          <el-input v-model="addruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="渠道描述" prop="content">
          <el-input v-model="addruleForm.content"></el-input>
        </el-form-item>
        <el-form-item label="显示状态" prop="status">
          <el-radio-group v-model="addruleForm.status">
            <el-radio label="0">不显示</el-radio>
            <el-radio label="1">显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否自动计算" prop="auto_type">
          <el-radio-group v-model="addruleForm.auto_type">
            <el-radio label="0">不自动计算</el-radio>
            <el-radio label="1">自动计算</el-radio>            
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addsubmitForm('addruleForm')"
            >添加内容</el-button
          >
          <el-button @click="addresetForm('addruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加版本弹框 -->

    <!-- 编辑版本弹框 -->
    <el-dialog  v-loading="editpageloading" title="编辑信息" :visible.sync="editVisible" width="50%">
      <el-form
        :model="editruleForm"
        ref="editruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="渠道ID" prop="channel_id" :readonly="true">
          <el-input v-model="editruleForm.channel_id"></el-input>
        </el-form-item>
        <el-form-item label="渠道名称" prop="name">
          <el-input v-model="editruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="渠道描述" prop="content">
          <el-input v-model="editruleForm.content"></el-input>
        </el-form-item>
        <el-form-item label="显示状态" prop="status">
          <el-radio-group v-model="editruleForm.status">
            <el-radio label="0">不显示</el-radio>
            <el-radio label="1">显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否自动计算" prop="auto_type">
          <el-radio-group v-model="editruleForm.auto_type">
            <el-radio label="0">不自动计算</el-radio>
            <el-radio label="1">自动计算</el-radio>            
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editsubmitForm('editruleForm')"
            >提交修改</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑弹框 -->
  </div>
</template>

<script>
// import { changeDateFormat } from "@/utils/util";
import { getcurrentTime } from "@/utils/public";
import { isString } from '../../utils/util';
export default {
  data() {
    return {
      pageloading: false,
      editpageloading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0, //请求列表的总条数
      userSearchData: {
        time: ""
      },
      // 添加版本信息数据
      addruleForm: {
        channel_id: "",
        name: "",
        content: "",        
        content: "",
        status: "",
        auto_type: ""
      },
      // 修改版本信息数据
      editruleForm: {
        id: "",
        channel_id: "",
        name: "",
        content: "",        
        content: "",
        status: "",
        auto_type: ""
      },
      tableData: [],
      versionListData: [],
      addVisible: false,
      editVisible: false
    };
  },

  mounted() {
    this.searchDataInfo();
  },

  methods: {
    changeDateFormat(time, format = 'YYYY-MM-DD hh:mm:ss') {
      if(!time) return '';
      var datetime = new Date(time);
      var o = {
          'Y+': datetime.getFullYear(),
          "M+": datetime.getMonth() + 1,
          "D+": datetime.getDate(),
          "h+": datetime.getHours(),
          "m+": datetime.getMinutes(),
          "s+": datetime.getSeconds(),
          "q+": Math.floor((datetime.getMonth() + 3) / 3),
          "S": datetime.getMilliseconds()
      };
      if (/(Y+)/.test(format)) format = format.replace(RegExp.$1, (datetime.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
              format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
          }
      }
      return format;
    },
    getAppName(item) {
      var string = ``;
      if (isString(item)) {
        for(var i=0; i<this.appids.length; i++) {
          var itemObject = this.appids[i];
          if (itemObject.app_id == item) {
            string = itemObject.name;
            break;
          }
        }
      }      
      return string;
    },
    // 添加用户弹框
    addversion() {
      this.addVisible = true;
    },
    // 添加用户按钮
    addsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let time = getcurrentTime();
          this.addruleForm.create_time = time;
          console.log(this.addruleForm);
          //添加版本
          this.addVersionData(this.addruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置添加用户
    addresetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 点击编辑行内容并更改数据
    edit(data) {
      this.editVisible = true;
      for(var k in data) {
        this.editruleForm[k] = data[k];
      }
      this.editruleForm.id = Number.parseInt(data.Id);
      this.editruleForm.app_name = this.getAppName(data.app_id);
      this.editruleForm.name = this.getChannelName(data.channel_id);
    },
    editsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editVisible = false;
          this.updateDataInfo(this.editruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editresetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 编辑version
    async updateDataInfo(requestObject) {
      this.$axios
        .post("/3699BIApi/ChannelId/UpdateData",{
            id: requestObject.id,
            channel_id: Number.parseInt(requestObject.channel_id), 
            name: requestObject.name,
            status: Number.parseInt(requestObject.status),
            content: requestObject.content,
            auto_type: Number.parseInt(requestObject.auto_type)
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          if (res.data.code == "200") {
            this.$message.success("编辑成功");
            this.searchDataInfo();
          } else {
            this.$message.error("编辑失败");
          }
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.searchData(this.userSearchData);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.searchData(this.userSearchData);
    },
    async addVersionData(requestObject) {
      this.editpageloading = true;
      this.$axios
      .post("/3699BIApi/ChannelId/AddData",{
            channel_id: Number.parseInt(requestObject.channel_id), 
            name: requestObject.name,
            status: Number.parseInt(requestObject.status),
            content: requestObject.content,
            auto_type: Number.parseInt(requestObject.auto_type)
      })
      .then(res => {
        this.editpageloading = false;
        if (res.data.code == "200") {
          this.addVisible = false;
          this.searchDataInfo();
          this.$message('添加成功！');
        }
        else {
          console.log(res.data.message);
          this.$message.error(`添加失败:${res.data.message}`);
        }
      });
    },
    async searchData(requestObject) {
      this.$axios
      .post("/3699BIApi/ChannelId/SearchData",{
          create_time: requestObject.time[0],
          update_time: requestObject.time[1],
          currentPage: this.currentPage,
          pageSize: this.pageSize
      })
      .then(res => {
          this.pageloading = false;
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.updateCurrpageData();
      });
    },
    searchDataInfo() {
      this.pageloading = true;
      this.searchData(this.userSearchData);
    },
    updateCurrpageData() {
      var arrays = [];
      var i = 0;
      var endi = this.total - (this.currentPage-1) * this.pageSize;
      if (endi > this.pageSize) {
        endi = this.pageSize;
      }
      console.log(`updateCurrpageData ${endi} 条`);
      for(; i<endi; i++) {
        if (i < this.total) {
          var itemObject = this.tableData[i];
          arrays.push(itemObject);
        }
      }
      
      this.versionListData = arrays.filter(val => {
        return val;
      });
    },
    async deleteDataInfo(data) {
      this.deleteData(data);
    },  
    // 删除
    async deleteData(data) {
      try {
        let msg = await this.$confirm("确认删除吗?");
        if (msg =  `confirm`) {
          this.deleteDataApi(data);
        }
      } catch (error) {
        return console.log("出错了：" + error);
      }
    },
    // 删除
    async deleteDataApi(data) {
      this.editpageloading = true;
      this.$axios
        .post("/3699BIApi/ChannelId/DeleteData",{
          id: Number.parseInt(data.Id)
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          this.pageloading = false;
          if (res.data.code == "200") {
            this.$message.success("删除成功");
            this.searchDataInfo();
          } else {
            this.$message.error("删除失败");
          }
        },
        (error)=>{
          this.editpageloading = false;
          this.$message('请求报错：' + error);
        });
    },
  }
};
</script>

<style lang="sass" scoped></style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         


// WEBPACK FOOTER //
// src/views/DataConfig/ChannelConfig.vue